module.exports = __webpack_public_path__ + "static/media/jobly.c0b6de27.gif";